import dayjs, { Dayjs } from 'dayjs'
import { TimeRange } from 'features/systemLens'
import { ChartTimeUnit } from 'types'

export function formatDuration(from: Dayjs, to: Dayjs) {
  const hours = to.diff(from, 'hours')
  const days = to.diff(from, 'days')
  const months = to.diff(from, 'months')

  if (hours < 24) {
    return `${hours}h`
  } else if (days < 31) {
    return `${days}d`
  } else {
    return `${months}mo`
  }
}

export function navigateTimeRange(
  direction: 'forward' | 'backward',
  zoom: boolean = false,
  fromTime: Dayjs,
  toTime: Dayjs,
  setTimeRange: React.Dispatch<React.SetStateAction<TimeRange>>,
  intervalValue: number,
  intervalUnit: ChartTimeUnit
) {
  const timeDiff = toTime.diff(fromTime, 'minutes')

  let newFrom: Dayjs
  let newTo: Dayjs

  if (direction === 'backward') {
    newFrom = fromTime.subtract(timeDiff, 'minutes')
    newTo = toTime.subtract(timeDiff, 'minutes')
  } else if (zoom) {
    newFrom = fromTime.add(timeDiff / 2, 'minutes')
    newTo = toTime
  } else {
    newFrom = fromTime.add(timeDiff, 'minutes')
    newTo = toTime.add(timeDiff, 'minutes')
  }

  // Don't allow navigating beyond current time
  const now = dayjs()
  if (newTo.isAfter(now)) {
    newTo = now
  }

  setTimeRange({
    from: newFrom.toISOString(),
    to: !zoom ? newTo.toISOString() : toTime.toISOString(),
    preset: 'custom',
    interval: intervalValue,
    intervalUnit: intervalUnit,
  })
}

// Check if we can navigate forward (not at current time)
export const canNavigateForward = (toTime: Dayjs) => {
  const now = dayjs()
  // Allow forward navigation if end time is more than 5 minutes before now
  return toTime.isBefore(now.subtract(5, 'minutes'))
}
